import React from 'react'
import Styles from './NewsThree.module.css'

function NewsThree() {
  return (
    <div className={Styles.main_page}>

      <h1>AVIS RENT A CAR </h1>
      <div className={Styles.s_box}>

        <p>
          Worldwide leader in car rental industry AVIS created in 1946 in USA is represented in Georgia since
          1999.
        </p>
        <p>
          Active in both Leisure and corporate sectors we combine company global standards with specific
          requirements of the local market.
        </p>
        <p>
          In corporate sector we collaborate with international organizations, companies, banks, embassies and
          different global and local projects active in Georgia during last 25 years.
        </p>
        <p>
          Our long-term fleet is adjusted with needs of our customers. Among them: constructing companies and
          oil industry with off-road requirements with highest HSE standards. Have been awarded multiple times
          accordingly.
        </p>
        <p>
          Technical services are combination of best experiences and standards of Avis and flexible to the
          standards and requirements of our loyal customers as well.
        </p>
        <p>
          High professional and well experienced chauffeur drive services are based on regular trainings and HSE
          standards.
        </p>
        <p>
          You can contact us and get exclusive deals for your short/long term rentals complying all your
          transportation needs.
        </p>
        <p>
          Wide range of the fleet, high standards of service, tailor made rentals and high level of after sale
          services create our value.
        </p>
        <p>
          We are evaluated by a huge global broker Rentalcars.com as the best car rental company in Georgia in
          2018, 2023 and 2024. Customer Favorite Awards granted.
        </p>

      </div>
    </div >
  )
}

export default NewsThree
